import { render, staticRenderFns } from "./team_members_add.vue?vue&type=template&id=de145690&"
import script from "./team_members_add.vue?vue&type=script&lang=js&"
export * from "./team_members_add.vue?vue&type=script&lang=js&"
import style0 from "./team_members_add.vue?vue&type=style&index=0&id=de145690&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports